import { useSession } from "next-auth/react";
import { type FC } from "react";
import { StackedArticleCard } from "@src/component/card";
import { StackedArticleLoading } from "@src/component/loading";
import { NoArticlesUploadedError } from "@src/component/miniComponent";
// import { AuthorArea } from "~/pages/dev/[username]";
// import { AuthorArea } from "~/pages/user-domain/[domain]";
import { type DataType } from "@src/types";
import { useSupabaseAuth } from "@src/utils/SupabaseAuthContext";
import { UserInterface } from "@src/utils/types";
import { AuthorArea } from "@src/component/pages/userDomain";

export interface LayoutProps {
  data: DataType[] | undefined;
  isLoading: boolean;
  author: UserInterface;
}

const Stacked: FC<LayoutProps> = ({ data, isLoading, author }) => {
  const { user } = useSupabaseAuth();
  return (
    <div className="w-full bg-light-bg dark:bg-primary">
      <AuthorArea author={author} />

      {isLoading ? (
        <div className="h-[50%] min-h-[24rem] rounded-md border border-border-light bg-gray-200 shadow-md dark:border-border dark:bg-primary-light"></div>
      ) : data && data.length > 0 ? (
        <div className="border-t border-border-light dark:border-border">
          <div className="mx-auto flex max-w-[1000px] flex-wrap gap-6 px-4 py-4 sm:py-8">
            {data.map((e) => (
              <StackedArticleCard key={e.id} article={e} />
            ))}
            {
              isLoading && (
                <>
                  <StackedArticleLoading />
                  <StackedArticleLoading />
                  <StackedArticleLoading />
                  <StackedArticleLoading />
                  <StackedArticleLoading />
                </>)
            }
          </div>
        </div>
      ) : (
        <NoArticlesUploadedError user={user} author={author} />
      )}
    </div>
  );
}

export default Stacked;
